import { Link } from "react-router-dom"
import { useAuth } from "../../hooks/useAuth"
import { defaultAvatar } from "@/utils/svgIcons"

export default function ProfileMenu() {
   const { user } = useAuth()

   if (!user) {
      return (
         <Link to="/connexion" className="btn btn-primary">
            Connexion
         </Link>
      )
   }

   return (
      <div className="flex items-center gap-2 rounded-full p-2">
         <span className="text-sm font-medium">{user.firstName}</span>
         <div className="avatar placeholder">
            <div className="w-10 rounded-full bg-neutral-focus text-neutral-content">
               {user.photo ? <img src={user.photo} alt={user.firstName || "?"} loading="lazy" /> :
                  <div className="h-10 w-10">{defaultAvatar}</div>
               }
            </div>
         </div>
      </div>
   )
}
